import { useEffect, useState } from "react";

import { apiRoot } from "../constants";

const useLocations = () => {
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    fetch(`${apiRoot}/locations/`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setLocations(json);
            setError(false);
            setLoading(false);

          });
        } else {
          setError(true);
          setLocations([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setLocations([]);
        setLoading(false);
      });
  }, []);

  return {
    locations,
    error,
    loading,
  };
};

export default useLocations;
